<template>
  <v-layout
    row
    wrap
    fill-height
  >
    <v-card
      class="mx-auto align-self-center"
      color="white"
      elevation-1
      hover
      width="400"
    >
      <v-card-title>
        <h1 class="primary--text font-weight-regular mx-auto">
          INICIAR SESION
        </h1>
      </v-card-title>

      <v-text-field
        v-model="document"
        append-icon="account_box"
        class="ma-4"
        label="Documento"
        hint="Si ya es <b>Paciente</b>, seguramente ya se encuentra <b>Registrado</b>."
        persistent-hint
      />

      <v-text-field
        v-model="password"
        :append-icon="show ? 'visibility' : 'visibility_off'"
        :type="show ? 'text' : 'password'"
        class="ma-4"
        label="Contraseña"
        hint="Ingrese con su <b>Día y Mes de Nacimiento</b>. Por ejemplo, si nació un <b>2 de Abril</b> su Contraseña es <b>0204</b>.<br> En caso de tener que Registrarse, debe ingresar la primera vez con la contraseña enviada por email para completar el Registro."
        persistent-hint
        @click:append="show = !show"
      />

      <v-card-actions>
        <v-btn
          :disabled="checkDisabled"
          class="primary ma-3"
          block
          large
          @click="checkDoc"
        >
          Ingresar
        </v-btn>
      </v-card-actions>

      <v-layout
        column
        class="ma-3"
      >
        <v-btn
          small
          class="error"
          @click="$router.replace({ name: 'PasswordRecoveryView' })"
        >
          Olvidaste tu contraseña?
        </v-btn>
        <v-btn
          small
          class="info"
          @click="$router.replace({ name: 'SignupView' })"
        >
          Registrarse
        </v-btn>
      </v-layout>
    </v-card>
  </v-layout>
</template>

<script>
import { verificarPaciente } from '../api/userEndpoints'
import { verificarTurno } from '../api/appointmentsEndpoints'
import { mapGetters } from 'vuex'

export default {
  name: 'LoginView',
  data () {
    return {
      document: null,
      password: null,
      show: false
    }
  },
  computed: {
    ...mapGetters(['getSelectedAppointment', 'getSelectionParams']),
    checkDisabled () {
      return !this.document
    }
  },
  methods: {
    async checkDoc () {
      const verifiedPatient = await verificarPaciente(this.document, this.password)
      if (verifiedPatient.respuesta === 'ERROR') {
        this.$createAlert({
          message: verifiedPatient.mensaje,
          type: 'error',
          duration: 5000
        })
      } else {
        await this.$store.dispatch('setUser', { patient: verifiedPatient.paciente })
        let appointmentVerified = ''
        let appointment = null
        if (this.getSelectedAppointment) {
          const patient = {
            pacienteId: verifiedPatient.paciente.pacienteId,
            obraSocial: this.getSelectionParams.selectedCobertura.obraSocial,
            plan: this.getSelectionParams.selectedCobertura.plan,
            prestacion: this.getSelectionParams.selectedPrestacion.prestacion
          }
          appointmentVerified = await verificarTurno(patient, this.getSelectedAppointment.turno)
          if (appointmentVerified.respuesta === 'OK') {
            appointment = { appointment: this.getSelectedAppointment, verification: appointmentVerified.mensaje }
            this.$router.replace({ name: 'AppointmentsView', params: { appointment } })
          } else {
            this.$createAlert({
              message: appointmentVerified.mensaje,
              type: 'error',
              duration: 5000
            })
            this.$router.replace({ name: 'SelectionView' })
            if (appointmentVerified.respuesta === 'ERRORDATOS') {
              this.$router.replace({ name: 'SettingsView' })
            }
          }
        } else {
          this.$router.replace({ name: 'AppointmentsView' })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
